import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";

const CheckStatus = () => {
  const [txnNo, setTxnNo] = useState("");
  const [transactionData, setTransactionData] = useState(null);
  const [error, setError] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const txnNoFromUrl = params.get("TnxNo");

    if (txnNoFromUrl) {
      setTxnNo(txnNoFromUrl);
      fetchTransactionDetails(txnNoFromUrl);
    } else {
      setError("Transaction number not found in the URL.");
    }
  }, [location]);

  const fetchTransactionDetails = async (transactionNumber) => {
    try {
      const response = await fetch("/check-status", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ txnNo: transactionNumber }),
      });

      if (response.ok) {
        const data = await response.json();
        setTransactionData(data);
      } else {
        const errorData = await response.json();
        setError(errorData.error || "Failed to fetch transaction details.");
      }
    } catch (error) {
      setError("An error occurred: " + error.message);
    }
  };

  const handleDownloadReceipt = () => {
    const element = document.getElementById("receipt-container"); // Get the HTML element with the content

    const options = {
      filename: `Transaction_Receipt_${txnNo}.pdf`,
      html2canvas: {
        scale: 2, // Higher scale for better quality
        useCORS: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf().from(element).set(options).save();
  };

  return (
    <div className="check-status-container" style={{ maxWidth: "600px", margin: "0 auto", padding: "20px", border: "1px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
      <div id="receipt-container" style={{ textAlign: "center", padding: "20px" }}>
        {/* Logo and Name Section */}
        <div style={{ height: "100px", background: "#eee", marginBottom: "10px" }}>
          <img src="rama_logo.jpg" alt="Logo" className="navbar-logo-image" style={{ width: "60px", height: "40px" }} />
        </div>
        <h2 style={{ margin: "0", fontSize: "24px" }}>Rama Group Of Institutes</h2>
        <p style={{ margin: "0", fontSize: "16px", color: "#555" }}>Transaction Receipt</p>

        {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}

        {transactionData ? (
          <div>
            <table style={{ width: "100%", marginBottom: "20px", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Merchant Transaction Number:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.MerTxnNo}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Name:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.Name}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Father Name:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData["Father Name"]}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Mother Name:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData["Mother Name"]}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Class:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.Class}</td>
                </tr>
                {transactionData.Class === "B.ED" && transactionData.subject1 && (
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Subject 1:</td>
                    <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.subject1}</td>
                  </tr>
                )}
                {transactionData.Class === "B.ED" && transactionData.subject2 && (
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Subject 2:</td>
                    <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.subject2}</td>
                  </tr>
                )} 
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Session:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.Session}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Amount:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.Amount}</td>
                </tr>
                {transactionData.exam && (
                  <>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Examination Fees:</td>
                      <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>True</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Subject:</td>
                      <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.subject || 'N/A'}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Aadhar Card:</td>
                      <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.aadhar || 'N/A'}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>College Roll No:</td>
                      <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.collegeRoll || 'N/A'}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Email:</td>
                      <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.email || 'N/A'}</td>
                    </tr>
                  </>
                )}
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Status:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData.Status}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "10px", borderBottom: "1px solid #ddd" }}>Date & Time:</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{transactionData["Date & Time"]}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <p>Loading transaction details...</p>
        )}
      </div>

      {/* This is where the button remains visible in the UI but excluded from the PDF */}
      <div style={{ textAlign: "center" }}>
        <button onClick={handleDownloadReceipt} style={{ padding: "10px 20px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}>
          Download Receipt
        </button>
      </div>
    </div>
  );
};

export default CheckStatus;
